
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.137","height":"8.002"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_29879","data-name":"Group 29879","transform":"translate(-1077.414 -452)","fill":"#5a677c"}},[_c('path',{attrs:{"id":"Union_65","data-name":"Union 65","d":"M16428.449 10119h-5.533a.5.5 0 01-.422-.771l2.938-4.573a.5.5 0 01.842 0l2.363 3.688 1.2-1.745a.5.5 0 01.824 0l1.8 2.618a.5.5 0 01-.412.784z","transform":"translate(-15345 -9659)"}}),_c('circle',{attrs:{"id":"Ellipse_455","data-name":"Ellipse 455","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1084 452)"}})])])
          )
        }
      }
    